import React from 'react';
import { Center } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Button, IconButton } from '@fiverr-private/button';
import { PlusIcon, UploadIcon } from '@fiverr-private/visuals';
import { getContext } from '@fiverr-private/fiverr_context';
import { IdleBodyProps } from '../types';

const IdleBody = ({ disabled, multiple, variant, theme }: IdleBodyProps) => {
  const { isTouch } = getContext();
  const isDark = theme === 'dark';

  if (variant === 'lean') {
    return (
      <IconButton
        disabled={disabled}
        aria-label={translate<string>('dropzone.idle_body.button_text')}
        size="md"
        variant="ghost"
        colorScheme={isDark ? 'white' : undefined}
      >
        <PlusIcon size="sm" />
      </IconButton>
    );
  }

  const lightColor = disabled ? 'bodySecondary' : 'bodyPrimary';

  return (
    <Center gap="3">
      {!isTouch && (
        <Typography color={isDark ? 'grey_300' : lightColor}>
          <I18n k={multiple ? 'dropzone.idle_body.text_multi' : 'dropzone.idle_body.text'} />
        </Typography>
      )}
      <Button
        disabled={disabled}
        variant="outline"
        tabIndex={-1}
        colorScheme={isDark ? 'white' : undefined}
        type="button"
      >
        <UploadIcon />
        <I18n k={multiple ? 'dropzone.idle_body.button_text_multi' : 'dropzone.idle_body.button_text'} />
      </Button>
    </Center>
  );
};

IdleBody.displayName = 'IdleBody';
IdleBody.id = 'IdleBody';

export default IdleBody;
